<template>
<div class="convention-hall page">
  <van-nav-bar
      class="nav-bar"
      title="预约大厅"
  />
  <div class="convention-item">
    <div class="left">
      <van-sidebar @change="onChange" v-model="activeKey">
        <van-sidebar-item title="全部" />
        <van-sidebar-item v-for="(v,key) in lotteryitem" :key="key" :title="v.name" />
      </van-sidebar>
    </div>
    <div class="right">
      <van-pull-refresh :border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
        <van-grid :column-num="2">
          <van-grid-item @click="toLottery(v.key,v.id)" v-for="(v,key) in gameitem" :key="key">
            <van-image class="game_item_img" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="circular"/>
              </template>
            </van-image>
            <span>{{v.name}}</span>
            <span>{{v.desc}}</span>
          </van-grid-item>
        </van-grid>
      </van-pull-refresh>
    </div>
  </div>
</div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      gameitem: [{},{},{},{}],
      lotteryitem: [{},{},{},{}],
      isLoading: false,
      activeKey: 0,
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
		
        Toast(this.$t('common.refresh'));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key,id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/Lottery?key='+key+"&id="+id})
      }
    },
    async getGameItem(){
      if (!localStorage.getItem('token')) {
        this.$router.replace('/Login');
        return;
      }
      try {
        let res = await this.$http({ method: 'get', url: 'lottery_hot' });
        let tasks = Array.isArray(res.data) ? res.data : [];
        if (!tasks.length) {
          res = await this.$http({ method: 'get', url: 'lottery_list' });
          tasks = Array.isArray(res.data) ? res.data : [];
        }
        this.gameitem = tasks;
        const task = tasks.find(item => item && item.id && item.key);
        if (task) {
          this.$router.replace({ path: '/Lottery', query: { key: task.key, id: task.id } });
        } else {
          Toast(this.$t('common.nodata'));
        }
      } catch (error) {
        Toast(this.$t('common.networkError'));
      }
    },
    onChange(index) {
      this.$http({
        method: 'get',
        data:{class:index},
        url: 'lottery_list'
      }).then(res=>{
        this.gameitem = res.data;
      })
    },
    getLotteryItem(){
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res=>{
        this.lotteryitem = res.data;
      })
    }
  },
  created() {
	this.getGameItem();//直接进入后台返回的首个任务
  }
};
</script>

<style lang='less' scoped>
.page{
  position: absolute!important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}
.nav-bar{
  background: linear-gradient(
      90deg,#7e5678,#e6c3a1);
  height: 100px;

}
.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
.van-sidebar {
  width: 180px;
}
.van-sidebar-item--select::before {
  left: 10px;
  height: 44%;
  background-color: #7e5678;
  border-radius: 5px;
  width: 10px;
}

.van-sidebar-item--select {
  color: #7e5678;
  font-size: 35px;
  text-align: center;
}
.van-sidebar-item{
  font-size: 35px;
  text-align: center;
  padding: 50px;
  background-color: #ffffff;
}
.van-sidebar-item--select, .van-sidebar-item--select:active {
  background-color: #f2f2f5;;
}
.convention-item{
  display: flex;
  align-items: center;
  height: calc(100% - 15px);
}
.convention-hall{
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: #f2f2f5;
}
.convention-item .left{
  height: 100%;
  background-color: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.convention-item .right{
  height: 100%;
  flex: 1;
  background-color: #f2f2f5;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.convention-item .right .list-wrapper{
  padding: 20px 20px;
  min-height: 800px;
}
.convention-item .right .list-wrapper .game_item_img{
  width: 200px;
  height: 200px;
}
.convention-item .right .list-wrapper span{
  margin-top: 10px;
  font-size: 30px;
  color: #000;
}
.convention-item .right .list-wrapper span:last-child{
  margin-top: 10px;
  font-size: 24px;
  color: #000;
}
.van-grid-item {
  padding: 10px;

}
::v-deep .van-grid-item__content--center {
  border-radius: 15px;
}
::v-deep .van-image__img{
  border-radius: 40px;
}
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

/* 预约入口在窄屏下使用弹性侧栏与等比卡片 */
@media (max-width: 430px) {
  .page {
    position: relative !important;
    inset: auto;
    width: 100%;
    max-width: 100vw;
    min-height: 100dvh;
    padding-top: env(safe-area-inset-top);
    padding-bottom: calc(4.75rem + env(safe-area-inset-bottom));
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .page,
  .page * {
    box-sizing: border-box;
  }

  .nav-bar {
    flex: 0 0 auto;
    min-height: 3.25rem;
    height: clamp(3rem, 14vw, 3.5rem);
  }

  ::v-deep .nav-bar .van-nav-bar__content {
    height: 100%;
    min-height: 3.25rem;
  }

  ::v-deep .nav-bar .van-nav-bar__title {
    width: calc(100% - 5rem);
    max-width: calc(100% - 5rem);
    font-size: 1.05rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .convention-hall {
    bottom: auto;
  }

  .convention-item {
    align-items: stretch;
    width: 100%;
    min-height: calc(100dvh - 3.5rem - 4.75rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));
    height: auto;
  }

  .convention-item .left {
    flex: 0 0 clamp(5.25rem, 27vw, 7rem);
    width: clamp(5.25rem, 27vw, 7rem);
    height: auto;
    min-width: 0;
    overflow-x: hidden;
  }

  .van-sidebar {
    width: 100%;
  }

  ::v-deep .van-sidebar-item {
    min-height: 3.5rem;
    padding: .8rem .35rem;
    font-size: .82rem;
    line-height: 1.3;
    text-align: center;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  ::v-deep .van-sidebar-item--select {
    font-size: .86rem;
  }

  ::v-deep .van-sidebar-item--select::before {
    left: .25rem;
    width: .2rem;
    height: 56%;
  }

  .convention-item .right {
    flex: 1 1 auto;
    min-width: 0;
    height: auto;
  }

  .convention-item .right .list-wrapper {
    width: 100%;
    min-width: 0;
    min-height: 0;
    padding: .65rem;
  }

  ::v-deep .convention-item .van-grid,
  ::v-deep .convention-item .van-grid-item,
  ::v-deep .convention-item .van-grid-item__content {
    min-width: 0;
  }

  .van-grid-item {
    padding: .3rem;
  }

  ::v-deep .van-grid-item__content--center {
    justify-content: flex-start;
    min-height: 100%;
    padding: .65rem .4rem;
    overflow: hidden;
    border-radius: .85rem;
  }

  .convention-item .right .list-wrapper .game_item_img {
    width: min(100%, 6rem);
    height: auto;
    aspect-ratio: 1 / 1;
    overflow: hidden;
  }

  ::v-deep .game_item_img .van-image__img {
    width: 100%;
    height: 100%;
    border-radius: .75rem;
    object-fit: cover;
  }

  .convention-item .right .list-wrapper span {
    width: 100%;
    margin-top: .45rem;
    font-size: .82rem;
    line-height: 1.3;
    text-align: center;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .convention-item .right .list-wrapper span:last-child {
    margin-top: .25rem;
    font-size: .72rem;
    line-height: 1.35;
  }

  ::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    font-size: .85rem;
  }
}

@media (max-width: 350px) {
  .convention-item .left {
    flex-basis: 4.75rem;
    width: 4.75rem;
  }

  .convention-item .right .list-wrapper {
    padding: .45rem;
  }

  .van-grid-item {
    padding: .2rem;
  }

  ::v-deep .van-grid-item__content--center {
    padding: .5rem .3rem;
  }
}
</style>
